import WzPage from './wz/wz-page'
import AppAccountBar from './app/app-account-bar'
import AppMyAward from './app/app-my-award'

const components = {
  WzPage,
  AppAccountBar,
  AppMyAward
}

export default (Vue) => {
  function register(compMap) {
    Object.keys(compMap).forEach((name) => {
      const c = compMap[name]
      if (c) {
        Vue.component(c.name || name, c)
      }
    })
  }
  register(components)
}
